"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AircraftSeatsConfiguration = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const AircraftSeatsPlan_1 = require("../../AircraftSeatsPlan");
const Legends_1 = require("./Legends");
require("./AircraftSeatsConfiguration.scss");
const className = 'aircraft-seats-config';
const AircraftSeatsConfiguration = (props) => {
    const { actionsComponent, onSeatClick, onSeatDoubleClick, sections, selectedSeats, modificators, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__body` },
                react_1.default.createElement("div", { className: `${className}__aircraft` },
                    react_1.default.createElement(AircraftSeatsPlan_1.AircraftSeatsPlan, { mode: 'edit', sections: sections, selectedSeats: [], activeSeats: selectedSeats, onSeatClick: onSeatClick, onSeatDoubleClick: onSeatDoubleClick })),
                react_1.default.createElement("div", { className: `${className}__content` },
                    react_1.default.createElement("h3", { className: `${className}__title` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/AircraftSeatsConfigurationPopup:Title', defaultMessage: 'Chose an action and select a seat(s) at the plan:' })),
                    react_1.default.createElement("div", { className: `${className}__actions` }, actionsComponent),
                    react_1.default.createElement("div", { className: `${className}__legends` },
                        react_1.default.createElement(Legends_1.Legends, null)))))));
};
exports.AircraftSeatsConfiguration = AircraftSeatsConfiguration;
//# sourceMappingURL=index.js.map